/* eslint-disable react-hooks/exhaustive-deps */
import { Container } from "@material-ui/core";
import React, { useContext, useState, useEffect } from "react";
import { useNavigate } from "react-router";
import PageTitle from "../../components/pageTitle/PageTitle";
import ThemeTable from "../../components/Table/ThemeTable";
import CommonContext from "../../hooks/commonContext";
import AuthContext from "../../hooks/authContext.js";
import {
  datetimest,
  getFormatedDate,
  getFormatedTime,
  getTimeZoneDate,
  groupByKey,
} from "../../services/helpers";
import {
  archiveIssueApi,
  getIssuesList,
  subscribeToIssuesList,
  updateBoldStatus,
} from "../../services/apiservices/issues.js";
import { Columns } from "./IssuesManageTableColumns";
import { useMediaQuery } from "@mui/material";
import IssueCommonCard from "../../components/ResponsiveCardComponent/IssuesComponent/IssuesListPageResponsive.jsx";
import { getAllEmployee } from "../../services/apiservices/employee.js";
import { Archive, Eye, Flag,Search } from "lucide-react";
import { Input } from "../../components/ui/input.jsx";
import SingleSelectNew from "../../components/SelectField/SingleSelectNew.jsx";
import { Badge } from "../../components/ui/badge.jsx";
import { Button } from "../../components/ui/button.jsx";
import { getSettings } from "../../services/apiservices/settings.js";
import { useToast } from "../../hooks/useToast.js";
import { CommonConfirmationDialog } from "../../components/DialogComponent/SupplyDataDialog.jsx";

function IssueManagement(props) {
  const history = useNavigate();
  const commonContext = useContext(CommonContext);
  const [allIssues, setAllIssues] = useState([]);
  const [filteredList, setFilteredList] = useState([]);
  const [allClient, setAllClients] = useState([]);
  const [allStatus, setAllStatus] = useState([]);
  const [allPriority, setAllPriority] = useState([]);
  const [searchTerm, setsearchTerm] = useState("");
  const { userProfile } = useContext(AuthContext);
  const auth = useContext(AuthContext);
  const [isLoading, setIsLoading] = React.useState(false);
  const [dialogOpen, setDialogOpen] = React.useState(false);
  const [issue, setIssue] = React.useState(null);
  const isMobile = useMediaQuery("(max-width:767px)");
  const isLandscape = useMediaQuery(
    "(min-width: 771px) and (max-width: 940px)"
  );
  const [settingsData, setSettingsData] = React.useState();
  const { toast } = useToast();
  const [filter, setFilterValues] = React.useState({
    priority: "any",
    client: "any",
    status: "all",
  });
  const localClientID = localStorage.getItem('clientId');
  const localCompanyId = localStorage.getItem('companyId');
  const companyId = auth?.userProfile?.role === "Client" ? localCompanyId ? localCompanyId : auth?.userProfile?.companyId : auth?.userProfile?.role === "companyUser" ? auth?.userProfile?.id : auth?.userProfile?.companyId;
  const clientId = localClientID ? localClientID : auth?.userProfile?.client;

  const checkRowSearch = (searchTerm, row) => {
    const lowerSearch = String(searchTerm).toLowerCase();
    return (
      String(row.status).toLowerCase().includes(lowerSearch) ||
      String(row.clientName).toLowerCase().includes(lowerSearch) ||
      String(row.priority).toLowerCase().includes(lowerSearch) ||
      String(row.issueNumber).toLowerCase().includes(lowerSearch)
    );
  };

  const checkFilteredList = () => {
    if (!allIssues || !Array.isArray(allIssues)) return;

    const filteredSuppliesList = allIssues.filter((row) => {
      const matchesSearch =
        searchTerm?.trim() === "" ? true : checkRowSearch(searchTerm, row);

      const matchesStatus =
        !filter.status || filter.status === "all"
          ? true
          : String(row.status).toLowerCase() === filter.status.toLowerCase();

      const matchesClient =
        !filter.client || filter.client === "any"
          ? true
          : String(row.clientName).toLowerCase() ===
            filter.client.toLowerCase();

      const matchesPriority =
        !filter.priority || filter.priority === "any"
          ? true
          : String(row.priority).toLowerCase() ===
            filter.priority.toLowerCase();

      return matchesSearch && matchesStatus && matchesClient && matchesPriority;
    });

    setFilteredList(filteredSuppliesList);
  };

  useEffect(() => {
    checkFilteredList();
  }, [allIssues, filter, searchTerm]);
  const manageDataList = (newRows) => {
    let allStatus = groupByKey(newRows, "status");
    let allStatusOptions = Object.keys(allStatus)?.map((acitem) => {
      return { label: acitem, value: acitem };
    });
    let finalSetAllStatus = allStatusOptions ? allStatusOptions : [];
    setAllStatus([...finalSetAllStatus]);

    // set data for filter fields
    let allclients = groupByKey(newRows, "clientName");
    let allclientOptions = Object.keys(allclients)?.map((acitem) => {
      return { label: acitem, value: acitem };
    });
    let finalSetAllClient = allclientOptions ? allclientOptions : [];
    setAllClients([...finalSetAllClient]);

    let allPriority = groupByKey(newRows, "priority");
    let allPriorityOptions =
      allPriority &&
      Object.keys(allPriority).map((aacitem) => {
        return { label: aacitem, value: aacitem };
      });
    let finalSetAllPriority = allPriorityOptions ? allPriorityOptions : [];
    setAllPriority([...finalSetAllPriority]);
  };

  // const fetchIssuesList = async () => {
  //   setIsLoading(true);
  //   try {
  //     const [employeeRes, issuesRes] = await Promise.all([
  //       new Promise((resolve, reject) => getAllEmployee(resolve, reject)),
  //       new Promise((resolve, reject) =>
  //         getIssuesList(companyId, resolve, reject)
  //       ),
  //     ]);
  //     const Inactive = employeeRes?.data.filter(
  //       (item) =>
  //         item.companyId === companyId &&
  //         (item.status === false || item.deleted)
  //     );

  //     let filteredRecords = issuesRes?.filter((item) => (!item.storedData || item.storedData.boldClass !== false));

  //     if (filteredRecords?.length === 0) {
  //       auth.resetIssueCount();
  //     } else {
  //       auth.setIssueCount(filteredRecords?.length);
  //     }
  //     const details = issuesRes?.filter(
  //       (item) =>
  //         !item?.archive &&
  //         (auth?.userProfile?.role !== "Client" ||
  //           item?.client?.id === clientId)
  //     );
  //     let newRows = details?.map((ritem) => {
  //       const data = employeeRes?.data.find(
  //         (item) => item.userId === ritem?.employee?.id
  //       );
  //       const createdBy = employeeRes?.data?.find(
  //         (item) => item.id === ritem?.createdBy
  //       );
  //       return {
  //         ...ritem,
  //         isuueId: `IS - ${String(ritem?.issueNumber)
  //           .match(/\d+/)?.[0]
  //           .padStart(4, "0")}`,
  //         employeeName: ritem?.employee?.name,
  //         clientName: ritem?.client?.name,
  //         dateOfRequest: ritem?.dateOfRequest,
  //         inactive: Inactive,
  //         timeZone: data?.timeZone,
  //         createdUser: createdBy
  //           ? `${createdBy?.firstName} ${createdBy?.lastName}`
  //           : "Unknown",
  //       };
  //     });

  //     let sortedData = sortingFunction(newRows);
  //     await manageDataList(sortedData);
  //     await setAllIssues(sortedData);
  //   } catch (error) {
  //     console.log("Error fetching issues:", error);
  //   } finally {
  //     setIsLoading(false);
  //   }
  // };
  // useEffect(() => {
  //   fetchIssuesList();
  //   getSettings("issue_settings", (res) => {
  //     if (res?.data.length > 0) {
  //       const filteredData = res?.data?.filter(
  //         (item) => item?.companyId === companyId && !item.deleted
  //       );
  //       const data = filteredData?.[0];
  //       setSettingsData(data);
  //     } else {
  //       setSettingsData();
  //     }
  //   });
  // }, []);

  const subscribeAndProcessIssues = (companyId, clientId, employeeRes) => {
    setIsLoading(true);

    const unsubscribe = subscribeToIssuesList(
      companyId,
      async (issuesRes) => {
        try {
          const Inactive = employeeRes?.data.filter(
            (item) => item.companyId === companyId && (item.status === false || item.deleted)
          );

          const filteredRecords = issuesRes?.filter((item) => item?.readUser && !item?.readUser?.includes(auth?.userProfile?.id));

          if (filteredRecords?.length === 0) {
            auth.resetIssueCount();
          } else {
            auth.setIssueCount(filteredRecords?.length);
          }

          const details = issuesRes?.filter(
            (item) => !item?.archive && (auth?.userProfile?.role !== "Client" || item?.client?.id === clientId)
          );

          const newRows = details?.map((ritem) => {
            const data = employeeRes?.data?.find((item) => item?.userId === ritem?.employee?.id);
            const createdBy = employeeRes?.data?.find((item) => item?.id === ritem?.createdBy);

            return {
              ...ritem,
              isuueId: `IS - ${String(ritem?.issueNumber).match(/\d+/)?.[0].padStart(4, "0")}`,
              employeeName: ritem?.employee?.name,
              clientName: ritem?.client?.name,
              dateOfRequest: ritem?.dateOfRequest,
              inactive: Inactive,
              timeZone: data?.timeZone,
              createdUser: createdBy ? `${createdBy?.firstName} ${createdBy?.lastName}` : "Unknown",
              createdEmail: createdBy ? createdBy?.email : ""
            };
          });

          const sortedData = sortingFunction(newRows);
          await manageDataList(sortedData);
          await setAllIssues(sortedData);
          setIsLoading(false);
        } catch (err) {
          console.log("Error processing issues:", err);
        }
      },
      (error) => {
        console.log("Subscription error:", error);
        setIsLoading(false);
      }
    );

    return unsubscribe;
  };

  useEffect(() => {
    let unsubscribeIssues = null;

    const initializeData = async () => {
      try {
        setIsLoading(true);

        const employeeRes = await new Promise((resolve, reject) =>
          getAllEmployee(resolve, reject)
        );

        unsubscribeIssues = subscribeAndProcessIssues(companyId, clientId, employeeRes);

        getSettings("issue_settings", companyId, (res) => {
          if (res?.data?.length > 0) {
            const filteredData = res?.data?.filter(
              (item) => !item.deleted
            );
            setSettingsData(filteredData?.[0]);
          } else {
            setSettingsData();
          }
        });
        setIsLoading(false);
      } catch (error) {
        console.log("Error initializing data:", error);
      }
    };

    initializeData();

    return () => {
      unsubscribeIssues && unsubscribeIssues();
    };
  }, []);

  const sortingFunction = (data) => {
    const result = data.sort((a, b) => {
      if (a.updatedAt > b.updatedAt) return -1;
      if (a.updatedAt < b.updatedAt) return 1;

      if (a.isuueId < b.isuueId) return -1;
      if (a.isuueId > b.isuueId) return 1;

      if (a.employeeName < b.employeeName) return -1;
      if (a.employeeName > b.employeeName) return 1;

      return 0;
    });

    return result;
  };

  const setFilter = (name, value) => {
    setFilterValues({ ...filter, [name]: value });
  };

  const handleArchiveAction = async () => {
    setDialogOpen(false);
    if (issue && issue !== "") {
      commonContext?.setLoader(true);
      const email = [issue?.createdByEmail];
      await archiveIssueApi(
        issue?.id,
        issue?.issueNumberInt,
        email,
        issue?.createdBy,
        async (res) => {
          // fetchIssuesList();
          setIssue(null);
          toast?.({
            title: "Success",
            description: "Message Successfully Archived",
          });
        },
        (resError) => {
          commonContext?.setLoader(false);
        }
      );
      commonContext?.setLoader(false);
    }
  };

  const handleArchiveTicketDialogClose = () => {
    setDialogOpen(false);
    setIssue(null);
  };

  const handleArchive = (record) => {
    setDialogOpen(true);
    setIssue(record);
  };

  const onHandelClickFunction = async (id) => {
    await redirectToDetails(id);
    await updateBoldStatus(id, userProfile.id);
  };

  const redirectToDetails = (id) => {
    if (typeof id !== "undefined" && id !== "") history("/operations/issues/manage/" + id);
  };
  const redirectToArchivedPage = () => {
    history("/operations/issues/archive");
  };

  const IssuePriorityBadge = ({ priority }) => {
    const getBadgeStyles = () => {
      switch (priority) {
        case "High":
          return "bg-red-100 text-red-800 hover:bg-red-100";
        case "urgent":
          return "bg-orange-100 text-orange-800 hover:bg-orange-100";
        case "Medium":
          return "bg-yellow-100 text-yellow-800 hover:bg-yellow-100";
        case "Low":
          return "bg-green-100 text-green-800 hover:bg-green-100";
        default:
          return "bg-gray-100 text-gray-800 hover:bg-gray-100";
      }
    };

    return (
      <Badge className={`font-medium ${getBadgeStyles()}`} variant="outline">
        {priority?.charAt(0).toUpperCase() + priority?.slice(1)}
      </Badge>
    );
  };

  const renderRowCell = (rcellItem, hcellItem, index, rowindex) => {
    let boldclasss = !rcellItem?.readUser?.includes(auth?.userProfile?.id);
    const timeZone = rcellItem?.timeZone
      ? rcellItem?.timeZone
      : "America/New_York";
    switch (hcellItem.id) {
      case "isuueId":
        return (
          <div className="d-flex">
            {boldclasss === true && (
              <Flag className="h-4 w-4 mr-5 text-red-500 fill-red-500" />
            )}
            <p
              // className="color-newBlack"
              style={{ fontSize: "14px", fontWeight: "500" }}
            >
              {rcellItem?.isuueId}
            </p>
          </div>
        );
      case "dateOfRequest":
        return (
          <p>
            {getFormatedDate(rcellItem?.dateOfRequest)}{" "}
          </p>
        );
      case "lastupdated":
        return (
          <p>
            {getTimeZoneDate(rcellItem?.updatedAt, timeZone)}{" "}
          </p>
        );
      case "lastupdatedtime":
        return (
          <p>
            {getFormatedTime(rcellItem?.updatedAt, timeZone)}{" "}
          </p>
        );
      case "raisedBy":
        return <p>{rcellItem?.createdUser}</p>;

      case "employeeName":
        const isInactive = rcellItem?.inactive?.some(
          (inactiveEmp) => inactiveEmp?.id === rcellItem?.employee.id
        );
        return (
          <p
            style={{ color: isInactive ? "#9fa6b3" : "" }}
          >
            {rcellItem?.employeeName}
          </p>
        );

      case "priority":
        return <IssuePriorityBadge priority={rcellItem?.priority} />;
      case "action":
        return (
          <>
            <Button
              variant="outline"
              size="sm"
              className="text-purple-600 border-purple-200 hover:bg-purple-50 hover:text-purple-700 h-8 w-8 p-0"
              onClick={() => onHandelClickFunction(rcellItem?.id)}
            >
              <Eye size={16} />
              <span className="sr-only">View Issue</span>
            </Button>
            <Button
              variant="outline"
              size="sm"
              className={
                "text-amber-600 border-amber-200 hover:bg-amber-50 hover:text-amber-700 h-8 w-8 p-0 ml-10"
              }
              onClick={() => {
                setDialogOpen(true);
                setIssue(rcellItem);
              }}
              disabled={rcellItem?.status !== "Closed"}
            >
              <Archive size={16} />
              <span className="sr-only">{"Archive Issue"}</span>
            </Button>
          </>
        );

      default:
        return <p>{rcellItem[hcellItem?.id]} </p>;
    }
  };


  return (
    <Container>
      <PageTitle
        pageTitle="Issue Management"
        showBreadcrumb={[{ label: "Home", to: "/" }, { label: "Operations"}, { label: "Issue"}]}
        BreadCrumbCurrentPageTitle={"Manage"}
        showLastSeen={true}
        buttonTitle="Issues Archive"
        buttonClass={"d-flex flex-center"}
        buttonStyle={{
          color: "white",
          backgroundColor: "#16A34A",
          padding: "8px 16px",
          borderRadius: "5px",
        }}
        buttonClick={() => redirectToArchivedPage()}
      />
      <div className={isMobile ? "" : "p-24"}>
        <div style={{ margin: "0px auto" }}>
          <div
            className={
              isMobile
                ? "d-flex flex-direction-column pv-15 ph-12"
                : "d-flex flex-space-between flex-center mv-24"
            }
          >
            <div className="flex flex-col">
              <div className="flex items-center text-xl font-semibold text-slate-800 dark:text-white">
                Manage Issues 
              </div>
              <p className="text-sm text-slate-500 mt-1">
                View and manage your logged issues
              </p>
            </div>
          </div>
          <div
            className={isMobile ? "mh-10" : `sectionBox2 dark:bg-[#1A1F2C] shadow-md dark:shadow-[0_0_12px_rgba(2,8,23,0.8)]`}
            style={{
              // borderRadius: isMobile ? "" : "8px",
              // border: isMobile ? "" : "1px solid hsl(214.3, 31.8%, 91.4%)",
            }}
          >
          <div
            className={
              isMobile
                ? "d-flex flex-direction-column flex-center w-100"
                : "d-flex flex-center flex-space-between"
            }
          >
            <div
              className="mt-5"
              style={{
                maxWidth: isMobile ? "400px" : "65%",
                marginBottom: isMobile ? "10px" : "",
                position: "relative",
                width: "100%",
              }}
            >
              <div className="relative mb-4">
                <Search
                  className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-500"
                  size={18}
                />
                <Input
                  placeholder="Search issues..."
                  className="pl-40 bg-white dark:bg-[#0F1729]"
                  value={searchTerm ? searchTerm : ""}
                  onChange={(event) => {
                    setsearchTerm(event.target.value);
                  }}
                />
              </div>
            </div>
            <div
              className={
                isMobile ? "d-flex flex-direction-column" : "d-flex flex-center"
              }
            >
              <div
                className={isMobile ? "" : "ml-15"}
                style={{ width: isMobile ? "400px" : "200px" }}
              >
                <SingleSelectNew
                  id="status"
                  placeholder="Status"
                  options={
                    allStatus
                      ? [{ label: "All Status", value: "all" }, ...allStatus]
                      : [{ label: "All Status", value: "all" }]
                  }
                  onChange={(value) => {
                    setFilter("status", value);
                  }}
                  value={filter?.status ? filter?.status : "all"}
                />
              </div>
              <div
                className={isMobile ? "mv-15" : "mh-15"}
                style={{ width: isMobile ? "400px" : "200px" }}
              >
                <SingleSelectNew
                  id="priority"
                  placeholder="Priority"
                  options={
                    allPriority
                      ? [
                          { label: "Any Priority", value: "any" },
                          ...allPriority,
                        ]
                      : [{ label: "Any Priority", value: "any" }]
                  }
                  onChange={(value) => {
                    setFilter("priority", value);
                  }}
                  value={filter?.priority ? filter?.priority : "any"}
                />
              </div>
              <div
                className={isMobile ? "mb-15" : ""}
                style={{ width: isMobile ? "400px" : "200px" }}
              >
                <SingleSelectNew
                  id="client"
                  placeholder="Client"
                  options={
                    allClient
                      ? [{ label: "Any Clients", value: "any" }, ...allClient]
                      : [{ label: "Any Clients", value: "any" }]
                  }
                  onChange={(value) => {
                    setFilter("client", value);
                  }}
                  value={filter?.client ? filter?.client : "any"}
                />
              </div>
            </div>
          </div>
            {!isMobile && !isLandscape && (
              <ThemeTable
                rows={filteredList}
                headCells={Columns}
                hidePagination={false}
                isLoading={isLoading}
                renderRowCell={renderRowCell}
                sorting={true}
              />
            )}
            {(isMobile || isLandscape) && (
              <>
                {filteredList?.map((record, index) => {
                  return (
                    <IssueCommonCard
                      index={index}
                      record={record}
                      redirectToDetails={onHandelClickFunction}
                      handelUnArchive={handleArchive}
                      issue={true}
                      settingsData={settingsData}
                    />
                  );
                })}
              </>
            )}
          </div>
        </div>
      </div>
      <CommonConfirmationDialog
        open={dialogOpen}
        onConfirm={handleArchiveAction}
        onClose={handleArchiveTicketDialogClose}
        title={"Archive Issue"}
        message={
          "Are you sure you want to archive this issue? This action will move the issue to the archive and cannot be undone."
        }
        buttonTitle={"Yes, archive issue"}
      />
    </Container>
  );
}

export default IssueManagement;
